import { gql } from '@apollo/client'
import fragments from '../../fragments'

export const GET_PROJECT_INVITATIONS = gql`
  query ProjectInvitations($projectId: ID!) {
    projectInvitations(projectId: $projectId) {
      ...ProjectInvitation
    }
  }
  ${fragments.projectInvitation}
`

export const ADD_PROJECT_INVITATION = gql`
  mutation AddProjectInvitation(
    $inviterId: String!
    $projectId: ID!
    $userEmail: String!
    $projectRole: ProjectRole!
    $defaultInvestorId: ID
    $guestName: String
  ) {
    addProjectInvitation(
      inviterId: $inviterId
      projectId: $projectId
      userEmail: $userEmail
      projectRole: $projectRole
      defaultInvestorId: $defaultInvestorId
      guestName: $guestName
    ) {
      ...ProjectInvitation
    }
  }
  ${fragments.projectInvitation}
`

export const EDIT_PROJECT_INVITATION = gql`
  mutation EditProjectInvitation(
    $projectId: ID!
    $userEmail: String!
    $projectRole: ProjectRole!
    $defaultInvestorId: ID
    $guestName: String
  ) {
    editProjectInvitation(
      projectId: $projectId
      userEmail: $userEmail
      projectRole: $projectRole
      defaultInvestorId: $defaultInvestorId
      guestName: $guestName
    ) {
      ...ProjectInvitation
    }
  }
  ${fragments.projectInvitation}
`

export const RESEND_PROJECT_INVITATION = gql`
  mutation ResendProjectInvitation($projectId: ID!, $userEmail: String!) {
    resendProjectInvitation(projectId: $projectId, userEmail: $userEmail) {
      ...ProjectInvitation
    }
  }
  ${fragments.projectInvitation}
`

export const DELETE_PROJECT_INVITATION = gql`
  mutation DeleteProjectInvitation($projectId: ID!, $userEmail: String!) {
    deleteProjectInvitation(projectId: $projectId, userEmail: $userEmail)
  }
`

const mutations = {
  addRemote: ADD_PROJECT_INVITATION,
  saveRemote: EDIT_PROJECT_INVITATION,
  deleteRemote: DELETE_PROJECT_INVITATION,
  saveOp: 'editProjectInvitation',
  addOp: 'addProjectInvitation',
  deleteOp: 'deleteProjectInvitation',
}

export const projectInvitationQueries = { ...mutations, getRemote: GET_PROJECT_INVITATIONS }
